export default __webpack_public_path__ + "media/packs/images/pcibex-w-ea55cb9bd6acd67dae46db5577d2e884.png";